import { useDispatch } from "react-redux";
import {
  isEditBreakDownValue,
  setEditBreakDownInformation,
  toggleAddOrEditBreakDownPopUp,
} from "../../../../Redux/Actions/ManageBreakDownAction";

const BreakDownTableActions = ({ rowData }) => {
  const dispatch = useDispatch();
  return (
    <button
      className="addBtnn2"
      onClick={() => {
        toggleAddOrEditBreakDownPopUp(dispatch, true);
        isEditBreakDownValue(dispatch, true);
        setEditBreakDownInformation(dispatch, rowData);
      }}
    >
      Edit
    </button>
  );
};

export default BreakDownTableActions;
